import type { ReactNode } from 'react';
import { Stack } from '@mui/material';

export const DrawerHeader = ({ icon, title }: { icon: ReactNode; title: string }) => (
  <Stack component="span" direction="row" spacing={1} gap={1} alignItems="center">
    {icon}
    {title}
  </Stack>
);
